import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/app/layouts/admin.vue").then(m => m.default || m)),
  blank: defineAsyncComponent(() => import("/app/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  error: defineAsyncComponent(() => import("/app/layouts/error.vue").then(m => m.default || m))
}